import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { TEAM_MOBILE_MEDIA_QUERY } from "../pages/Team/utils/teamUiUtils";
import { isPopupEquipePath, mapPopupEquipeToAppPath } from "../utils/teamNavigation";

/**
 * No mobile, /popup-equipe/* redireciona para /equipe/* (com topo e menu do app).
 */
export default function PopupEquipeMobileRedirect({ children }) {
  const isMobile = useMediaQuery(TEAM_MOBILE_MEDIA_QUERY);
  const location = useLocation();
  const navigate = useNavigate();

  const shouldRedirect =
    isMobile && isPopupEquipePath(location.pathname);

  useEffect(() => {
    if (!shouldRedirect) return;
    const target = mapPopupEquipeToAppPath(location.pathname, location.search);
    if (!target) return;
    const current = `${location.pathname}${location.search}`;
    if (target === current) return;
    navigate(target, { replace: true });
  }, [shouldRedirect, location.pathname, location.search, navigate]);

  if (shouldRedirect) return null;

  return children;
}
